module.exports = __webpack_public_path__ + "img/19.effefaa1.png";